export interface IPlatformBenefit {
  id: string;
  icon: string;
  title: string;
  description: string;
}

export const PLATFORM_BENEFITS: IPlatformBenefit[] = [
  {
    id: '1',
    icon: 'grid',
    title: 'Manage Leagues Easily',
    description: 'Create And Manage Leagues With Intuitive Tools For Scheduling, Team Registration, And Standings.',
  },
  {
    id: '2',
    icon: 'phone',
    title: 'Track Match Scores',
    description: 'Live Scoring With Ball-By-Ball Updates, Detailed Statistics, And Real-Time Leaderboard Updates.',
  },
  {
    id: '3',
    icon: 'trophy',
    title: 'Organize Tournaments',
    description: 'Live Scoring With Ball-By-Ball Updates, Detailed Statistics, And Real-Time Leaderboard Updates.',
  },
  {
    id: '4',
    icon: 'users',
    title: 'Connect With Players',
    description: 'Live Scoring With Ball-By-Ball Updates, Detailed Statistics, And Real-Time Leaderboard Updates.',
  },
];
